module.exports = __webpack_public_path__ + "img/Popup_bob_desktop.4094cf3.png";